import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { FunderUsersService, UsuarioService, FundersService } from '../../services/service.index';
import { Router } from '@angular/router';
import swal2 from 'sweetalert2';

@Component({
  selector: 'app-crearfunderuser',
  templateUrl: './crearfunderuser.component.html',
  styleUrls: ['./funderusers.component.css']
})
export class CrearFunderUserComponent implements OnInit {
  @Output() childEvent = new EventEmitter();
  forma: FormGroup;
  usuarios: any[] = [];
  usuariosFiltrados: any[] = [];
  usuarioSeleccionado: any = null;
  fondeadores: any[] = [];
  fondeadoresFiltrados: any[] = [];
  fondeadorSeleccionado: any = null;

  constructor(
    public _funderUsersService: FunderUsersService,
    public _usuarioService: UsuarioService,
    public _fundersService: FundersService,
    public router: Router
  ) {}

  ngOnInit() {
    this.forma = new FormGroup({
      funder_id: new FormControl(null, Validators.required),
      user_id: new FormControl(null, Validators.required)
    });

    this._usuarioService.getUsuarios().subscribe(
      resp => { this.usuarios = resp; },
      err => { console.error('Error cargando usuarios:', err); }
    );

    this._fundersService.getfundersfinancial().subscribe(
      resp => { this.fondeadores = resp; },
      err => { console.error('Error cargando fondeadores:', err); }
    );
  }

  filtrarUsuarios(event) {
    const query = event.query.toLowerCase();
    this.usuariosFiltrados = this.usuarios.filter(u =>
      (u.name && u.name.toLowerCase().includes(query)) ||
      (u.email && u.email.toLowerCase().includes(query))
    );
  }

  seleccionarUsuario(event) {
    this.usuarioSeleccionado = event;
    this.forma.patchValue({ user_id: event.id });
  }

  limpiarUsuario() {
    this.usuarioSeleccionado = null;
    this.forma.patchValue({ user_id: null });
  }

  filtrarFondeadores(event) {
    const query = event.query.toLowerCase();
    this.fondeadoresFiltrados = this.fondeadores.filter(f =>
      (f.nombre_fondeador && f.nombre_fondeador.toLowerCase().includes(query))
    );
  }

  seleccionarFondeador(event) {
    this.fondeadorSeleccionado = event;
    this.forma.patchValue({ funder_id: event.id_funder });
  }

  limpiarFondeador() {
    this.fondeadorSeleccionado = null;
    this.forma.patchValue({ funder_id: null });
  }

  registrarFunderUser() {
    if (this.forma.invalid || !this.usuarioSeleccionado || !this.fondeadorSeleccionado) {
      swal2.fire('Campos requeridos', 'Todos los campos son obligatorios', 'info');
      return;
    }

    swal2.showLoading();
    const params = {
      funder_user: {
        funder_id: this.forma.value.funder_id,
        user_id: this.forma.value.user_id
      }
    };

    this._funderUsersService.createFunderUser(params).subscribe(
      resp => {
        swal2.close();
        swal2.fire({
          title: 'Asociación creada exitosamente',
          text: '',
          icon: 'success',
          showConfirmButton: true,
          showCancelButton: false,
          allowOutsideClick: false
        }).then(res => {
          if (res.value) { this.cerrar(); }
        });
      },
      (err) => {
        swal2.close();
        console.error(err);
        swal2.fire('Error al crear asociación', '', 'error');
      }
    );
  }

  cerrar() {
    this.childEvent.emit({ message: 'cerrarcrearfunderuser' });
  }
}
